__turbopack_context__.v({
  "chevron": "HeaderNavigation-module__yG0Rtq__chevron",
  "chevronOpen": "HeaderNavigation-module__yG0Rtq__chevronOpen",
  "dropdown": "HeaderNavigation-module__yG0Rtq__dropdown",
  "dropdownLink": "HeaderNavigation-module__yG0Rtq__dropdownLink",
  "loadingText": "HeaderNavigation-module__yG0Rtq__loadingText",
  "navItemWrap": "HeaderNavigation-module__yG0Rtq__navItemWrap",
  "navLink": "HeaderNavigation-module__yG0Rtq__navLink",
  "navLinkActive": "HeaderNavigation-module__yG0Rtq__navLinkActive",
  "navWrapper": "HeaderNavigation-module__yG0Rtq__navWrapper",
});
